import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { FeatureFlags } from './models/FeatureFlags';
import { ExternalApiConfig, ExternalApiConfigResponse } from './models/ExternalApiConfig';
import { Store } from '@ngxs/store';
import { DealerState } from '../state/DealerState';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FeatureflagsService {
  public http = inject(HttpClient);
  public store = inject(Store);

  constructor() {}

  async fetchFeatureFlag(dealerId, flagName) {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.featureFlags.replace('{dealerId}', dealerId)}`;
    return await lastValueFrom(
      this.http.get<FeatureFlags>(url, {
        params: { name: flagName }
      })
    );
  }

  async fetchAllFeatureFlags(dealerId: string): Promise<FeatureFlags> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.featureFlags.replace('{dealerId}', dealerId)}`;
    return await lastValueFrom(
      this.http.get<FeatureFlags>(url, {
        params: { name: 'All' }
      })
    );
  }

  async saveFeatureFlags(dealerId: string, flags: { [key: string]: boolean }): Promise<FeatureFlags> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.featureFlags.replace('{dealerId}', dealerId)}`;
    return await lastValueFrom(this.http.put<FeatureFlags>(url, { flags }));
  }

  async fetchAllExternalApiConfig(dealerId: string): Promise<ExternalApiConfigResponse> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.externalApiConfig.replace('{dealerId}', dealerId)}`;
    return await lastValueFrom(this.http.get<ExternalApiConfigResponse>(url, { params: { name: 'All' } }));
  }

  async saveExternalApiConfig(dealerId: string, config: ExternalApiConfig): Promise<ExternalApiConfigResponse> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.externalApiConfig.replace('{dealerId}', dealerId)}`;
    return await lastValueFrom(this.http.put<ExternalApiConfigResponse>(url, { config }));
  }

  public getFeatureFlagValue(flag: string) {
    let featureFlags = this.store.selectSnapshot(DealerState.featureFlags);
    return featureFlags.flags[flag] ? featureFlags.flags[flag] : false;
  }
}
